import localforage from "localforage";
import { useCallback } from "react";

interface UsePersistState<T> {
  persistState: (key: string, value: T, onSuccess?: () => void) => void;
  getPersistedState: (key: string, onSuccess?: () => void) => Promise<T | null>;
}
const usePersistState = <T>(): UsePersistState<T> => {
  const persistState = useCallback((key: string, value: any, onSuccess?: () => void) => {
    localforage.setItem(key, value, onSuccess);
  }, []);

  const getPersistedState = useCallback((key: string, onSuccess?: () => void) => {
    return localforage.getItem<T>(key);
  }, []);

  return {
    persistState,
    getPersistedState,
  };
};

export default usePersistState;
